import type React from 'react';
import { useLabelListDownload } from '@/pages/catalogImport';
import { BarcodeIssuesView } from './BarcodeIssuesView';
import { useBarcodeIssues, type BarcodeIssuesProps } from './useBarcodeIssues';

const NO_LABELS: never[] = [];

/**
 * The tab's state owner: its list and fix through `useBarcodeIssues`, and the
 * label list download of the last fix's generated barcodes through the
 * catalog import's `useLabelListDownload`, so both label lists are the same
 * file.
 */
export const BarcodeIssuesContent: React.FC<BarcodeIssuesProps> = ({
    branchId,
    isEnabled,
}) => {
    const state = useBarcodeIssues(branchId, isEnabled);
    const download = useLabelListDownload(
        state.success?.generatedBarcodes ?? NO_LABELS,
        state.success?.fixedAt ?? '',
    );

    return <BarcodeIssuesView download={download} state={state} />;
};
